import { LinkNames } from 'mockStores/lib/types';

export const LINK_TO_PATH_MAP = {
  [LinkNames.Continue]: { exact: true, to: '/continue' },
  [LinkNames.Directory]: { exact: true, to: '/' },
  [LinkNames.AccountLinking]: { exact: true, to: '/account-linking' },
  [LinkNames.AccountLinkingNoShipping]: { exact: true, to: '/account-linking-no-shipping' },
  [LinkNames.NoFlows]: { exact: true, to: '/no-flows-store' },
  [LinkNames.SPBv4]: { exact: true, to: '/spb-v4-store' },
  [LinkNames.SPBv5]: { exact: true, to: '/spb-v5-store' },
  [LinkNames.GuestPayPalButton]: { exact: true, to: '/guest-paypal-button' },
  [LinkNames.Vcc]: { exact: true, to: '/vcc-store' },
  [LinkNames.LegacyPayPal]: { exact: true, to: '/legacy-paypal-store' },
  [LinkNames.LegacyPayPalResult]: { exact: false, to: '/legacy-paypal-store/result' },
  [LinkNames.MockVcc]: { exact: true, to: '/mock-vcc' },
};

const ACCOUNT_LINKING_STAGING_CLIENT_ID = 'B_A3dv9noA1CWNyMLPxFkgYx1M5HfTSZmHK5GmFr6GKuUCOEPc9XjJ0B9cnW1hJY6bHIX-m9bO0DcYnio4';
const DEBUG = process.env.NODE_ENV === 'development' ? '&debug=true' : '';
export const ACCOUNT_LINKING_PAYPAL_SDK_URL = `https://www.te-honey.qa.paypal.com/sdk/js?client-id=${ACCOUNT_LINKING_STAGING_CLIENT_ID}${DEBUG}`;
